// extracted by mini-css-extract-plugin
module.exports = {"JobSearchForm":"styles_JobSearchForm__CmOth","height":"styles_height__kQZks"};